/**
 * @generated SignedSource<<8c01bf97ba37ceb0221c4d97e4674698>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CharacterSelectPreviewMutation$variables = {
  id: string;
};
export type CharacterSelectPreviewMutation$data = {
  readonly previewVoice: {
    readonly wavBase64: string | null | undefined;
  };
};
export type CharacterSelectPreviewMutation = {
  response: CharacterSelectPreviewMutation$data;
  variables: CharacterSelectPreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "characterId",
        "variableName": "id"
      }
    ],
    "concreteType": "PreviewVoicePayload",
    "kind": "LinkedField",
    "name": "previewVoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wavBase64",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CharacterSelectPreviewMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CharacterSelectPreviewMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "96324074b74dd487ca7a70725eb11ab9",
    "id": null,
    "metadata": {},
    "name": "CharacterSelectPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation CharacterSelectPreviewMutation(\n  $id: ID!\n) {\n  previewVoice(characterId: $id) {\n    wavBase64\n  }\n}\n"
  }
};
})();

(node as any).hash = "d704500d7710eb739ee19dd7da3961ea";

export default node;
